export interface K {
    id: number;
    name: string;
    hide?: number;
    value: string;
    key?: string;
}

export interface InvitationThrough extends K { }
export interface Authentication extends K { }
export interface Confirmation extends K { }

export enum InvitationThroughEnum {
    EMAIL = 'email',
    EMAIL_AND_SMS = 'email_and_sms',
    POS = 'pos',
    IN_MEETING = 'in_meeting',
    GET_LINK = 'get_link',
    SMS = 'sms',
    SAME_DEVICE = 'same_device'
}

export enum ConfirmationTypeEnum {
    EMAIL = 'email',
    EMAIL_AND_SMS = 'email_and_sms',
    NO_CONFIRMATION = 'no_confirmation'
}

export enum RecipientTypeEnum {
    RECIPIENTTAB = 'recipientTab',
    RECIPIENTSETTINGS = 'recipientSettings',
}